import { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import useCity from "hooks/useCity";
import CitySettingsModal from "components/Cities/CitySettingsModal/CitySettingsModal";

/** Edit the identity fields that change rarely for one city. */
const EditCity = (props) => {
    const { loading, editCity, error } = useCity();
    const [name, setName] = useState("");
    const [topic, setTopic] = useState("");
    const [phone, setPhone] = useState("");
    const [location, setLocation] = useState("");

    useEffect(() => {
        setName(props.region?.name || "");
        setTopic(props.region?.topic || "");
        setPhone(props.region?.phone || "");
        setLocation(props.region?.location || "");
    }, [props.region]);

    const submit = async (event) => {
        event.preventDefault();
        const regionData = new FormData();

        regionData.append("id", props.region.id);
        regionData.append("name", name);
        regionData.append("topic", topic);
        regionData.append("phone", phone);
        regionData.append("location", location);

        try {
            const response = await editCity(regionData);
            if (!response) {
                props.showMessage("error", "هناك خطأ", error || "حدث خطأ غير متوقع");
                return;
            }

            props.showMessage("success", "تم التعديل", "تم تعديل المدينة بنجاح");
            props.close();
        } catch (err) {
            props.showMessage(
                "error",
                "هناك خطأ",
                err.response?.data?.message || error || "حدث خطأ غير متوقع",
            );
        }
    };

    return (
        <CitySettingsModal
            show={props.show}
            close={props.close}
            region={props.region}
            title="تعديل مدينة"
            loading={loading}
            onSubmit={submit}
            submitLabel="حفظ"
        >
            <Form.Group className="mb-3" controlId="cityName">
                <Form.Label>
                    اسم المدينة<span>*</span>
                </Form.Label>
                <Form.Control
                    type="text"
                    value={name}
                    onChange={(event) => setName(event.target.value)}
                    placeholder="اسم المدينة"
                    required
                />
            </Form.Group>
            <Form.Group className="mb-3" controlId="cityTopic">
                <Form.Label>
                    اسم المدينة باللغة الإنجليزية<span>*</span>
                </Form.Label>
                <Form.Control
                    type="text"
                    value={topic}
                    onChange={(event) => setTopic(event.target.value)}
                    placeholder="اسم المدينة باللغة الإنجليزية"
                    required
                />
            </Form.Group>
            <Form.Group className="mb-3" controlId="cityPhone">
                <Form.Label>
                    رقم الهاتف<span>*</span>
                </Form.Label>
                <Form.Control
                    type="text"
                    value={phone}
                    onChange={(event) => setPhone(event.target.value)}
                    placeholder="رقم الهاتف"
                    required
                />
            </Form.Group>
            <Form.Group className="mb-3" controlId="cityLocation">
                <Form.Label>الموقع</Form.Label>
                <Form.Control
                    type="text"
                    value={location}
                    onChange={(event) => setLocation(event.target.value)}
                    placeholder="الموقع"
                />
            </Form.Group>
        </CitySettingsModal>
    );
};

export default EditCity;
